/** Permission checks mirroring the API (hidden ≠ secure: the API enforces everything). */
import type { Me, PortalPermission } from "@/lib/types"

export type Permission =
  | "customers.view"
  | "customers.manage"
  | "bookings.view"
  | "bookings.create"
  | "bookings.confirm"
  | "bookings.cancel"
  | "invoices.view"
  | "invoices.issue"
  | "invoices.cancel"
  | "coordinators.view"
  | "coordinators.manage"
  | "agreements.manage"
  | "commissions.view"
  | "payouts.record"
  | "partners.view"
  | "partners.manage"
  | "contracts.view"
  | "contracts.upload"
  | "reports.view"
  | "expenses.view"
  | "expenses.manage"
  | "lookups.manage"

/** `me.permissions` already includes implied permissions (computed server-side). */
export function can(me: Me | null | undefined, code: Permission): boolean {
  if (!me || me.role !== "owner") return false
  return me.is_super_owner || me.permissions.includes(code)
}

export function isSuperOwner(me: Me | null | undefined): boolean {
  return !!me && me.role === "owner" && me.is_super_owner
}

/** Coordinator self-service permission (granted to all coordinators in settings). Always false for owners. */
export function portalCan(me: Me | null | undefined, code: PortalPermission): boolean {
  return !!me && me.role === "coordinator" && me.permissions.includes(code)
}
